import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { CustomButton } from '../../../_common';
import '../JobLogs.scss';
import '../../../_common/SearchableDropdown/SearchableDropdown.scss';
import { GetJobLogs_getJobLogs_details as JobLogDetailsType } from '../../../../types/schemaTypes';

interface StatsType {
    Id: number;
    Details: string;
    Boxes: number;
    Weight: string;
}

interface RunSheetDeatilsType {
    Id: number;
    OverallStage: string;
    Runsheet: string;
    isStageCompleted: boolean;
    Stats: StatsType[];
}

interface StageDetailsType {
    FracType: string;
    JobStageId: number;
    MaxStages: number;
    OverallStage: number;
    RowId: number;
    Stage: number;
    TotalStages: number;
    WellHead: string;
}

interface DetailsProps {
    isCompletedStatus: boolean;
    CustomerName: string;
    WellName: number;
    Region: string;
    CrewName: string;
    WellHeads: number;
    TotalStages: string;
    StartDate: string;
    EndDate: string;
    stageDetails: StageDetailsType[];
    EmailRunsheetDetails: RunSheetDeatilsType[];
    EmailInvDetails: StatsType[];
    Notes: string;
}

interface JobLogStageModalProps {
    jobId: number;
    jobLogsData: JobLogDetailsType | undefined;
    showModal: boolean;
    onClickCancel: () => void;
    isStartStage: boolean;
}

const JobLogStageModal = ({
    jobId,
    jobLogsData,
    showModal,
    onClickCancel,
    isStartStage,
}: JobLogStageModalProps): React.ReactElement => {
    const details: DetailsProps = JSON.parse(jobLogsData?.notes ?? '');

    let endYear = '';
    if (details.EndDate !== '') {
        const record = details.EndDate.split(' ');
        endYear = record[2];
    }
    if (!details) {
        return (
            <Modal show={showModal} onHide={onClickCancel} dialogClassName="JobLogs-Modal-Container">
                <Modal.Header className="JobLogs-Modal-Header">
                    <Modal.Title className="JobLogs-Modal-Header-Container">
                        <button className="material-icons JobLogs-Modal-X-Button" onClick={onClickCancel}>
                            close
                        </button>
                        <div className="JobLogs-Modal-Title">No details available.</div>
                    </Modal.Title>
                </Modal.Header>
            </Modal>
        );
    }

    return (
        <Modal show={showModal} onHide={onClickCancel} dialogClassName="JobLogs-Modal-Container">
            <Modal.Header className="JobLogs-Modal-Header">
                <Modal.Title className="JobLogs-Modal-Header-Container">
                    <button className="material-icons JobLogs-Modal-X-Button" onClick={onClickCancel}>
                        close
                    </button>
                    {/* <div className="JobLogs-Modal-Title">{details.isCompletedStatus ? 'Edit Job Log' : 'Add Job Log'}</div> */}
                </Modal.Title>
            </Modal.Header>

            <table className="JoblogStageModal-Table">
                <thead>
                    <tr>
                        <th colSpan={4} className="JoblogStageModal-Title">
                            {details.isCompletedStatus ? 'Stage End Alert' : 'Stage Start Alert'}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <th colSpan={4} className="JoblogStageModal-SubTitle">
                            Well Information
                        </th>
                    </tr>

                    <tr>
                        <td className="JoblogStageModal-Key">Customer Name</td>
                        <td className="JoblogStageModal-Value">{details.CustomerName}</td>
                        <td className="JoblogStageModal-Key">Pad Name</td>
                        <td className="JoblogStageModal-Value">{details.WellName}</td>
                    </tr>
                    <tr>
                        <td className="JoblogStageModal-Key">Region</td>
                        <td className="JoblogStageModal-Value">{details.Region}</td>
                        <td className="JoblogStageModal-Key">Crew Name</td>
                        <td className="JoblogStageModal-Value">{details.CrewName}</td>
                    </tr>
                    <tr>
                        <td className="JoblogStageModal-Key">Total Wellheads</td>
                        <td className="JoblogStageModal-Value">{details.WellHeads}</td>
                        <td className="JoblogStageModal-Key">Total Job Stages</td>
                        <td className="JoblogStageModal-Value">{details.TotalStages}</td>
                    </tr>

                    {details.stageDetails.map(stageDetail => (
                        <>
                            <tr className="JoblogStageModal-Border-Top">
                                <td className="JoblogStageModal-Key">Well Head {stageDetail.RowId}</td>
                                <td className="JoblogStageModal-Value">{stageDetail.WellHead}</td>
                                <td className="JoblogStageModal-Key">Type of Frac</td>
                                <td className="JoblogStageModal-Value">{stageDetail.FracType}</td>
                            </tr>
                            <tr className="JoblogStageModal-Border-Bottom">
                                <td className="JoblogStageModal-Key">Wellhead Stage</td>
                                <td className="JoblogStageModal-Value">{stageDetail.Stage}</td>
                                <td className="JoblogStageModal-Key">Overall Job Stages</td>
                                <td className="JoblogStageModal-Value">
                                    {stageDetail.OverallStage} of {stageDetail.TotalStages}
                                </td>
                            </tr>
                        </>
                    ))}

                    <tr>
                        <td className="JoblogStageModal-Key">Stage Start Time</td>
                        <td className="JoblogStageModal-Value">{details.StartDate}</td>
                        <td className="JoblogStageModal-Key">Stage End Time</td>
                        <td className="JoblogStageModal-Value">
                            {isStartStage && endYear && endYear == '1899' ? '' : details.EndDate}
                        </td>
                    </tr>
                </tbody>

                <tbody>
                    {details &&
                        details.EmailRunsheetDetails.map(runsheetDetail => (
                            <>
                                <tr>
                                    <th colSpan={4} className="JoblogStageModal-SubTitle">
                                        {details.isCompletedStatus
                                            ? 'Actual Sand Consumed'
                                            : 'Expected Sand Consumption'}{' '}
                                        for Stage {runsheetDetail.OverallStage} ({runsheetDetail.Runsheet})
                                    </th>
                                </tr>
                                <tr>
                                    <th colSpan={2}></th>
                                    <th>Boxes</th>
                                    <th>Weight</th>
                                </tr>

                                {runsheetDetail.Stats.map((stat, index) => (
                                    <tr key={index}>
                                        <td colSpan={2} className="JoblogStageModal-Key-RightAlign">
                                            {stat.Details}
                                        </td>
                                        <td className="JoblogStageModal-RightAlign">{stat.Boxes}</td>
                                        <td className="JoblogStageModal-RightAlign">{stat.Weight}</td>
                                    </tr>
                                ))}
                            </>
                        ))}
                </tbody>

                <tbody>
                    <tr>
                        <th colSpan={4} className="JoblogStageModal-SubTitle">
                            Onsite Inventory
                        </th>
                    </tr>
                    <tr>
                        <th colSpan={2}></th>
                        <th>Boxes</th>
                        <th>Weight</th>
                    </tr>

                    {details.EmailInvDetails.map((inventoryDetail, index) => (
                        <tr key={index}>
                            <td colSpan={2} className="JoblogStageModal-Key-RightAlign">
                                {inventoryDetail.Details}
                            </td>
                            <td className="JoblogStageModal-RightAlign">{inventoryDetail.Boxes}</td>
                            <td className="JoblogStageModal-RightAlign">{inventoryDetail.Weight}</td>
                        </tr>
                    ))}

                    <tr>
                        <th colSpan={4} className="JoblogStageModal-SubTitle">
                            Notes
                        </th>
                    </tr>
                    <tr>
                        <td colSpan={4} className="JoblogStageModal-Value">
                            {details.Notes}
                        </td>
                    </tr>
                </tbody>
            </table>

            <Modal.Footer className="JobLogs-Modal-Footer JoblogStageModal-Footer">
                <CustomButton title="Close" isBordered onClick={onClickCancel} />
            </Modal.Footer>
        </Modal>
    );
};

export default JobLogStageModal;
